(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-random-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ougist-random-products')) {
    customElements.define('ougist-random-products', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        const grid = this.querySelector('[data-random-grid]');
        const pool = this.querySelector('[data-random-pool]');
        if (!grid || !pool) return;
        const cards = [...grid.children, ...pool.content.children];
        const limit = Math.min(Number(this.dataset.limit) || 4, cards.length);
        for (let index = cards.length - 1; index > 0; index--) {
          const swap = Math.floor(Math.random() * (index + 1));
          [cards[index], cards[swap]] = [cards[swap], cards[index]];
        }
        grid.replaceChildren(...cards.slice(0, limit));
        pool.remove();
        this.dataset.initialized = 'true';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
